<script>
  import { onMount } from 'svelte';
  import { headerDisplayStore } from '../stores/General';
  import VastEditor from '../components/VastEditor.svelte';

  onMount(() => {
    headerDisplayStore.SetTitle('VAST Editor');
    headerDisplayStore.SetBreadCrumbs([
      {
        key: 'vastEditor',
        label: 'VAST Editor',
      },
    ]);
  });
</script>

<div class="py-6">
  <VastEditor />
</div>
